import { render, staticRenderFns } from "./Guandao.vue?vue&type=template&id=4a8f7e13&"
import script from "./Guandao.vue?vue&type=script&lang=js&"
export * from "./Guandao.vue?vue&type=script&lang=js&"
import style0 from "./Guandao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports